import { ArrowRightIcon } from '@heroicons/react/20/solid';
import FilterContainer from './FilterContainer';
import { useFilterContext } from './hooks';
import { DateCondition, DateFilterConfig } from './types';

type DateFilterProps = {
    title: string;
    id: string;
};

function DateFilter({ title, id }: DateFilterProps): JSX.Element {
    const filterInstance = useFilterContext();
    const filter = filterInstance.getFilterSection<DateFilterConfig>(id);

    return (
        <FilterContainer
            title={title}
            isOpen={filterInstance.getActiveFilterCount(id) > 0}
            activeFilterCount={filterInstance.getActiveFilterCount(id)}
        >
            <div className="p-2">
                <section className="flex items-start gap-2 text-gray-600 text-sm">
                    <label className="h-6 flex items-center text-gray-600 dark:text-white/[0.60]">is</label>
                    <select
                        className="shrink-0 rounded-md h-6 text-xs p-0 m-0 pl-2 w-28 focus focus:ring-indigo-500 focus:border-indigo-500 border border-gray-300 focus:outline-none dark:bg-white/[0.12] dark:text-white/[0.87] dark:border-0"
                        value={filter?.option.condition || '='}
                        onChange={(e): void => {
                            filterInstance.updateDateOption(id, {
                                ...filter.option,
                                condition: e.target.value as DateCondition,
                                to: undefined, // Reset the to value
                            });
                        }}
                    >
                        <option value="=">equal to</option>
                        <option value=">">greater than</option>
                        <option value="<">less than</option>
                        <option value="between">between</option>
                    </select>
                    <div className="h-6 flex items-center">
                        <ArrowRightIcon className="h-3 w-3 shrink-0 text-indigo-600 dark:text-indigo-400" />
                    </div>
                    <div className="flex flex-col items-center gap-0.5">
                        <input
                            type="date"
                            value={filter.option?.base === undefined ? '' : filter.option.base}
                            onChange={(e): void => {
                                const val = e.target.value.trim() === '' ? undefined : e.target.value.trim();
                                filterInstance.updateDateOption(id, { ...filter.option, base: val });
                            }}
                            className="w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block border border-gray-300 rounded-md h-6 text-xs px-1 dark:bg-white/[0.12] dark:text-white/[0.87] dark:border-0 dark:placeholder:text-white/[0.38]"
                        />

                        {/* Show an extra input */}
                        {filter?.option.condition === 'between' && (
                            <>
                                <label className="text-gray-600 text-sm dark:text-white/[0.60]">and</label>
                                <input
                                    value={filter?.option.to || ''}
                                    onChange={(e): void => {
                                        const val = e.target.value.trim() === '' ? undefined : e.target.value.trim();
                                        filterInstance.updateDateOption(id, { ...filter.option, to: val });
                                    }}
                                    type="date"
                                    className="w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block border border-gray-300 rounded-md h-6 text-xs px-1 dark:bg-white/[0.12] dark:text-white/[0.87] dark:border-0 dark:placeholder:text-white/[0.38]"
                                />
                            </>
                        )}
                    </div>
                </section>
            </div>
        </FilterContainer>
    );
}
export default DateFilter;
